import { Table } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

export const FinancialChartsDataGrid = ({ rows, columns, getRowKey }) => (
	<Table size="small" aria-label="a dense table">
		<TableHead>
			<TableRow style={{ backgroundColor: "#d8e6db" }}>
				{columns.map((column) => (
					<TableCell key={column.key} align={column.align ?? "left"}>
						{column.label}
					</TableCell>
				))}
			</TableRow>
		</TableHead>
		<TableBody>
			{rows.map((row) => (
				<TableRow key={getRowKey(row)}>
					{columns.map((column) => (
						<TableCell key={column.key} component="th" scope="row" align={column.align ?? "left"}>
							{column.render ? column.render(row[column.key], row) : row[column.key]}
						</TableCell>
					))}
				</TableRow>
			))}
		</TableBody>
	</Table>
);
